// removed by extract-text-webpack-plugin
module.exports = {"info":"yOxLd"};


//////////////////
// WEBPACK FOOTER
// ./src/components/present/ChannelMenuItem.css
// module id = 836
// module chunks = 0